import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { logindetails } from '../../services/login/logindetails';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  role: any = '';
  affliates: any;
  companyAfl: any;
  constructor(public router: Router) { }
  canActivate(_route: ActivatedRouteSnapshot) {
    let accessToken;
    if (globalThis.location.href.includes('/?code')) {
      accessToken = globalThis.location.href.split('?')[1].split('code=')[1].split('&')[0]; 
    }
    const codefromurl = sessionStorage.getItem('codeResponse');
    if (codefromurl !== null) {
      return true;
    }
    else {
      sessionStorage.setItem('redirectUrl', globalThis.location.href);
const env = (globalThis as any).environment;
if (!env?.baseLoginUrl) {
  throw new Error('Environment baseLoginUrl not found');
}
const redirectUrl = env.baseLoginUrl + logindetails.codeChallenge;
      globalThis.location.href = redirectUrl;
      return true;
    }
  }

  }